import { TEST_PIPELINE_TABS } from '../useTestPipelineTabs';

export default function buildOnPipelineIntegrationChange({
  integrationOutput,
  serverResponse,
  selectedTab,
  onSelectTab,
}) {
  return () => {
    integrationOutput.reset();
    serverResponse.reset();
    resetTab(selectedTab, onSelectTab);
  };
}

const DONT_RESET_TABS = [TEST_PIPELINE_TABS.INPUT_EVENT, TEST_PIPELINE_TABS.PIPELINE_OUTPUT];

function resetTab(selectedTab, onSelectTab) {
  if (DONT_RESET_TABS.includes(selectedTab)) {
    return;
  }
  onSelectTab(TEST_PIPELINE_TABS.PIPELINE_OUTPUT);
}
